// extracted by mini-css-extract-plugin
export var container = "Projects-module--container--9a264";
export var layout = "Projects-module--layout--106dd";
export var sliderWrapper = "Projects-module--sliderWrapper--bb01d";
export var slide = "Projects-module--slide--1b3d2";